import { displayCentsInDollars, lightTheme } from '@vgrubs/components';

const DOWN = '#2E7D32'; // green — price decreased

// Read `lightTheme` at call time (runtime), never at module top-level, to
// avoid a circular-init crash when this module loads before the styles barrel.
export const deltaColor = (delta: number) =>
  delta > 0 ? lightTheme.primary : delta < 0 ? DOWN : lightTheme.lightGray;

export const signedCents = (cents: number) =>
  `${cents > 0 ? '+' : cents < 0 ? '−' : ''}${displayCentsInDollars(
    Math.abs(cents)
  )}`;

export const signedPct = (pct: number) =>
  `${pct > 0 ? '+' : pct < 0 ? '−' : ''}${Math.abs(pct)}%`;
